import React from 'react';
import { connect } from 'react-redux';

import AuthModals from './AuthModals';

import { selectIsAuthenticated } from '../../redux/auth/user/selectors';

const AuthModalsConnected = (props) => <AuthModals {...props} />;

const mapStateToProps = (state, props) => ({
  isAuthenticated: selectIsAuthenticated(state, props),
});

export default connect(mapStateToProps)(AuthModalsConnected);
